import React from "react";

const ShippingIcon = () => (
  <svg
    version="1.1"
    id="shipping-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    height="30px"
    width="30px"
    viewBox="0 0 36 36"
    xmlSpace="preserve"
  >
    <g>
      <path d="M7.9,23.6c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5C10.4,24.7,9.3,23.6,7.9,23.6z" />
      <path d="M28.1,23.6c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5C30.6,24.7,29.5,23.6,28.1,23.6z" />
      <path
        d="M31.8,17.4L31.8,17.4l-2.5-5h-6.1v8.8h0V7.4H1.7v17.5h2.5c0.5-1.6,2-2.7,3.7-2.7c1.7,0,3.2,1.1,3.7,2.7h0
		c0,0,12.7,0,12.7,0c0.5-1.6,2-2.7,3.7-2.7c1.7,0,3.2,1.1,3.7,2.7h2.5v-6.1L31.8,17.4z M3.7,9.7c-0.2,0-0.4-0.2-0.4-0.4
		c0-0.2,0.2-0.4,0.4-0.4h17.5c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4H3.7z M22.9,23.2h-9.9c-0.2,0-0.4-0.2-0.4-0.4
		s0.2-0.4,0.4-0.4h9.9c0.2,0,0.4,0.2,0.4,0.4S23.1,23.2,22.9,23.2z M25.3,17.6v-3.2h3l1.6,3.2H25.3z"
      />
    </g>
  </svg>
);

export default ShippingIcon;



// WEBPACK FOOTER //
// ./src/components/AccordionGroup/AccordionIcons/ShippingIcon.js